import params from '@/param/param'

export default{
    getLocal(type){
        return JSON.parse(localStorage.getItem([type]))
    },
    
    setLocal(type, value){
        localStorage.setItem([type], JSON.stringify(value))
    },

    removeLocal(type){
        localStorage.removeItem([type])
    }
}


// WEBPACK FOOTER //
// ./src/services/appService.js